import { render, staticRenderFns } from "./NewsAppPushMessagesNotification.vue?vue&type=template&id=9a425342"
import script from "./NewsAppPushMessagesNotification.js?vue&type=script&lang=js&external"
export * from "./NewsAppPushMessagesNotification.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports